import React from 'react'
import { DropdownItem } from 'util/ui'
import { externalLink as ExternalLinkIcon } from 'assets/icons/groove/v2'

const MessengerLinkItem = ({ facebookLink }) => {
  return (
    <DropdownItem className="link-item" aria-checked="false">
      <a
        href={facebookLink}
        target="_blank"
        rel="noopener noreferrer"
        className="col"
      >
        <div className="name">View conversation in Messenger</div>
        <div className="icon">
          <ExternalLinkIcon />
        </div>
      </a>
    </DropdownItem>
  )
}

export default MessengerLinkItem
